module.exports = __webpack_public_path__ + "img/whats-app.43269480.svg";